import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalAction } from '../commissioning.model';
import { CommissioningService } from '../commissioning.service';
import { RemoteDeviceType } from '@store';

@Component({
  selector: 'app-commissioning-reminder-modal',
  templateUrl: './commissioning-reminder-modal.component.html',
  styleUrls: ['./commissioning-reminder-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningReminderModalComponent implements OnInit {
  readonly remoteDeviceType = RemoteDeviceType;

  constructor(
    public commissioningService: CommissioningService,
    private dialogRef: MatDialogRef<CommissioningReminderModalComponent>
  ) {}

  ngOnInit(): void {
    this.dialogRef.updateSize('768px');
    this.dialogRef.addPanelClass('commissioning-modal');
  }

  navigateBack(): void {
    this.commissioningService.modalAction$.next(ModalAction.PreviousStep);
  }

  navigateForward(): void {
    this.commissioningService.modalAction$.next(ModalAction.NextStep);
  }

  closeDialog(): void {
    this.commissioningService.modalAction$.next(ModalAction.Close);
  }
}
